import ScrollableContainer from "../../../Components/BonusUi/Scrollable/ScrollableContainer";

const Scrollable = () => {
  return <ScrollableContainer />;
};

export default Scrollable;
